module.exports = __webpack_public_path__ + "img/mg-pic-2.a6678fec.png";